import { type Contact } from "@repo/api";
import { t } from "@repo/translation";
import {
  LabelField,
  SectionContainer,
  TwoColumnSectionContainer,
  useSettings,
} from "@repo/ui";
import { maskEmail, maskName, maskPhoneNumber } from "@repo/utils";

interface Props {
  contactData?: Contact;
}

export const CustomerDetails = ({ contactData }: Props) => {
  const { customerMode } = useSettings();

  if (!contactData) {
    return null;
  }

  const lastName = contactData.customerContactDetails?.lastName;
  const phoneNumber =
    contactData.customerContactDetails?.contactTypeValues?.MOBILE;
  const email = contactData.customerContactDetails?.contactTypeValues?.EMAIL;

  return (
    <SectionContainer>
      <TwoColumnSectionContainer>
        <LabelField
          id="order-billing-first-name"
          label={t("label.first_name")}
          value={contactData.customerContactDetails?.firstName}
        />
        <LabelField
          id="order-billing-last-name"
          label={t("label.last_name")}
          value={customerMode ? maskName(lastName) : lastName}
        />
        {contactData.customerContactDetails?.businessName && (
          <LabelField
            id="order-billing-company-name"
            label={t("label.company_name")}
            value={contactData.customerContactDetails?.businessName}
          />
        )}
        <LabelField
          id="order-billing-customer-type"
          label={t("label.customer_type")}
          value={contactData.customerContactDetails?.customerType}
        />
        <LabelField
          id="order-billing-address"
          label={t("label.address")}
          value={customerMode ? "*****" : contactData.address?.addressLine1}
        />
        <LabelField
          id="order-billing-zip-code"
          label={t("label.postal_code")}
          value={contactData.address?.zipCode}
        />
        <LabelField
          id="order-billing-city"
          label={t("label.city")}
          value={contactData.address?.cityName}
        />
        <LabelField
          id="order-billing-country-code"
          label={t("label.country")}
          value={contactData.address?.countryCode}
        />
        <LabelField
          id="order-billing-preferred-contact-method"
          label={t("label.preferred_contact_method")}
          value={
            contactData.customerContactDetails?.preferredContactType === "EMAIL"
              ? t("label.email")
              : t("label.phone")
          }
        />
        <LabelField
          id="order-billing-phone"
          label={t("label.phone")}
          value={customerMode ? maskPhoneNumber(phoneNumber) : phoneNumber}
        />
        <LabelField
          id="order-billing-email"
          label={t("label.email")}
          value={customerMode ? maskEmail(email) : email}
        />
      </TwoColumnSectionContainer>
    </SectionContainer>
  );
};
